import { render, staticRenderFns } from "./compare-mode.component.vue?vue&type=template&id=2f7499c6&scoped=true"
import script from "./compare-mode.component.vue?vue&type=script&lang=ts"
export * from "./compare-mode.component.vue?vue&type=script&lang=ts"
import style0 from "./compare-mode.component.vue?vue&type=style&index=0&id=2f7499c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7499c6",
  null
  
)

export default component.exports